module.exports = __webpack_public_path__ + "static/alimentation-b61de32794c53f538dda5159d1c738f8.jpg";